import {defineMessages} from "@project/i18n";

export const expedientOffersMessages = defineMessages({
  search: {
    id: "sales.expedients.customerOffers.search",
    defaultMessage: "Search offers",
    description: "Search the owning Expedient by canonical displayed Offer number",
  },
  title: {
    id: "sales.expedients.customerOffers.title",
    defaultMessage: "Offers",
    description: "Canonical nested Expedient Offer title",
  },
  table: {
    id: "sales.expedients.customerOffers.table",
    defaultMessage: "Expedient Customer Offers",
    description: "Canonical nested Expedient Offer table",
  },
  open: {
    id: "sales.expedients.customerOffers.open",
    defaultMessage: "Open Offer",
    description: "Canonical nested Expedient Offer open",
  },
  opening: {
    id: "sales.expedients.customerOffers.opening",
    defaultMessage: "Opening Offer…",
    description: "Canonical nested Expedient Offer opening",
  },
  form: {
    id: "sales.expedients.customerOffers.form",
    defaultMessage: "Open Customer Offer",
    description: "Canonical nested Expedient Offer form",
  },
  help: {
    id: "sales.expedients.customerOffers.help",
    defaultMessage:
      "Open a blank draft with a language and currency, or start from an active Template. The server assigns the name and identity.",
    description: "Canonical nested Expedient Offer help",
  },
  template: {
    id: "sales.expedients.customerOffers.template",
    defaultMessage: "Starting Template",
    description: "Canonical nested Expedient Offer template",
  },
  templateHelp: {
    id: "sales.expedients.customerOffers.templateHelp",
    defaultMessage:
      "Language, currency and remembered values come from the Template. Template Notes are not copied.",
    description: "Canonical nested Expedient Offer templateHelp",
  },
  failed: {
    id: "sales.expedients.customerOffers.failed",
    defaultMessage: "Current Expedient Offers are unavailable.",
    description: "Canonical nested Expedient Offer failed",
  },
  loading: {
    id: "sales.expedients.customerOffers.loading",
    defaultMessage: "Loading current Expedient Offers…",
    description: "Canonical nested Expedient Offer loading",
  },
  unavailable: {
    id: "sales.expedients.customerOffers.unavailable",
    defaultMessage: "Opening and lifecycle changes require a current active Expedient.",
    description: "Canonical nested Expedient Offer unavailable",
  },
  accepted: {
    id: "sales.expedients.customerOffers.accepted",
    defaultMessage:
      "Opening accepted. Waiting for the actual Customer Offer; do not repeat the command.",
    description: "Canonical nested Expedient Offer accepted",
  },
  uncertain: {
    id: "sales.expedients.customerOffers.uncertain",
    defaultMessage:
      "The opening could not be confirmed. Review current Offers before opening another; do not repeat an uncertain request.",
    description: "Canonical nested Expedient Offer uncertain",
  },
  openEditor: {
    id: "sales.expedients.customerOffers.openEditor",
    defaultMessage: "Open editor",
    description: "Canonical nested Expedient Offer openEditor",
  },
  retry: {
    id: "sales.expedients.customerOffers.retry",
    defaultMessage: "Retry read",
    description: "Canonical nested Expedient Offer retry",
  },
  actions: {
    id: "sales.expedients.customerOffers.actions",
    defaultMessage: "Actions",
    description: "Canonical nested Expedient Offer actions",
  },
  preview: {
    id: "sales.expedients.customerOffers.preview",
    defaultMessage: "Preview Offer",
    description: "Canonical nested Expedient Offer preview",
  },
  version: {
    id: "sales.expedients.customerOffers.version",
    defaultMessage: "Revision",
    description: "Canonical nested Expedient Offer version",
  },
  empty: {
    id: "sales.expedients.customerOffers.empty",
    defaultMessage: "No Customer Offers match these filters.",
    description: "Canonical nested Expedient Offer empty",
  },
  filters: {
    id: "sales.expedients.customerOffers.filters",
    defaultMessage: "Filters",
    description: "Canonical nested Expedient Offer filters",
  },
  filterForm: {
    id: "sales.expedients.customerOffers.filterForm",
    defaultMessage: "Filter Expedient Offers",
    description: "Canonical nested Expedient Offer filterForm",
  },
  filterHelp: {
    id: "sales.expedients.customerOffers.filterHelp",
    defaultMessage: "Filter by language, currency or statuses. Parent identity remains fixed.",
    description: "Canonical nested Expedient Offer filterHelp",
  },
  ordinal: {
    id: "sales.expedients.customerOffers.ordinal",
    defaultMessage: "Offer chain",
    description: "Canonical nested Expedient Offer ordinal",
  },
  allLanguages: {
    id: "sales.expedients.customerOffers.allLanguages",
    defaultMessage: "All languages",
    description: "Unrestricted language selection in the parent-scoped Offer filters",
  },
  allStatuses: {
    id: "sales.expedients.customerOffers.allStatuses",
    defaultMessage: "All statuses",
    description: "Canonical nested Expedient Offer allStatuses",
  },
  invalid: {
    id: "sales.expedients.customerOffers.invalid",
    defaultMessage: "Review the language, currency or selected Template.",
    description: "Canonical nested Expedient Offer invalid",
  },
  clear: {
    id: "sales.expedients.customerOffers.clear",
    defaultMessage: "Clear filters",
    description: "Canonical nested Expedient Offer clear",
  },
  dismiss: {
    id: "sales.expedients.customerOffers.dismiss",
    defaultMessage: "Close",
    description: "Canonical nested Expedient Offer dismiss",
  },
  success: {
    id: "sales.expedients.customerOffers.success",
    defaultMessage: "Opening accepted.",
    description: "Canonical nested Expedient Offer success",
  },
  pending: {
    id: "sales.expedients.customerOffers.pending",
    defaultMessage: "Wait for the current operation to settle before leaving.",
    description: "Canonical nested Expedient Offer pending",
  },
  stay: {
    id: "sales.expedients.customerOffers.stay",
    defaultMessage: "Stay",
    description: "Canonical nested Expedient Offer stay",
  },
  leave: {
    id: "sales.expedients.customerOffers.leave",
    defaultMessage: "Continue navigation",
    description: "Canonical nested Expedient Offer leave",
  },
  chooseTemplate: {
    id: "sales.expedients.customerOffers.chooseTemplate",
    defaultMessage: "Choose Template",
    description: "Canonical nested Expedient Offer chooseTemplate",
  },
  changeTemplate: {
    id: "sales.expedients.customerOffers.changeTemplate",
    defaultMessage: "Change Template",
    description: "Canonical nested Expedient Offer changeTemplate",
  },
  removeTemplate: {
    id: "sales.expedients.customerOffers.removeTemplate",
    defaultMessage: "Remove Template selection",
    description: "Canonical nested Expedient Offer removeTemplate",
  },
  cancel: {
    id: "sales.expedients.customerOffers.cancel",
    defaultMessage: "Cancel",
    description: "Canonical nested Expedient Offer cancel",
  },
  pickerTitle: {
    id: "sales.expedients.customerOffers.pickerTitle",
    defaultMessage: "Offer templates",
    description: "Canonical nested Expedient Offer pickerTitle",
  },
  pickerEmpty: {
    id: "sales.expedients.customerOffers.pickerEmpty",
    defaultMessage: "No active Templates found.",
    description: "Canonical nested Expedient Offer pickerEmpty",
  },
  pickerSearch: {
    id: "sales.expedients.customerOffers.pickerSearch",
    defaultMessage: "Search offer templates",
    description: "Canonical nested Expedient Offer pickerSearch",
  },
  pickerSelect: {
    id: "sales.expedients.customerOffers.pickerSelect",
    defaultMessage: "Select",
    description: "Canonical nested Expedient Offer pickerSelect",
  },
  pickerApply: {
    id: "sales.expedients.customerOffers.pickerApply",
    defaultMessage: "Apply",
    description: "Canonical nested Expedient Offer pickerApply",
  },
  pickerNone: {
    id: "sales.expedients.customerOffers.pickerNone",
    defaultMessage: "No Template selected",
    description: "Canonical nested Expedient Offer pickerNone",
  },
  name: {
    id: "sales.expedients.customerOffers.name",
    defaultMessage: "Name",
    description: "Canonical nested Expedient Offer name",
  },
  state: {
    id: "sales.expedients.customerOffers.state",
    defaultMessage: "State",
    description: "Canonical nested Expedient Offer state",
  },
  language: {
    id: "sales.expedients.customerOffers.language",
    defaultMessage: "Language",
    description: "Canonical nested Expedient Offer language",
  },
  currency: {
    id: "sales.expedients.customerOffers.currency",
    defaultMessage: "Currency",
    description: "Canonical nested Expedient Offer currency",
  },
  openActions: {
    id: "sales.expedients.customerOffers.openActions",
    defaultMessage: "Offer actions",
    description: "Canonical nested Expedient Offer openActions",
  },
});
